export const CreateCardOnFileFormMessages = {
    SUCCESS_ALERT_MESSAGE: 'Credit card successfully added to profile.',
} as const;
